import * as React from 'react'
export function Heart({ title = 'Heart', className, variation, ...props }) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="https://www.w3.org/2000/svg"
      className={className}
      data-variation={variation}
      {...props}
    >
      <title>{title}</title>
      <g clip-path="url(#clip0_9893_2041)">
        <path
          d="M31.9584 19.975C31.9584 26.6583 26.5417 32.075 19.8584 32.075C13.175 32.075 7.75837 26.6583 7.75837 19.975C7.75837 13.2917 13.175 7.875 19.8584 7.875C26.5417 7.875 31.9584 13.2917 31.9584 19.975ZM19.8584 33.2583C18.7084 33.2583 17.775 34.1917 17.775 35.3417V37.6417C17.775 38.7917 18.7084 39.725 19.8584 39.725C21.0084 39.725 21.9417 38.7917 21.9417 37.6417V35.3417C21.9417 34.1917 21.0084 33.2583 19.8584 33.2583ZM19.8584 6.46667C21.0084 6.46667 21.9417 5.53333 21.9417 4.38333V2.08333C21.9417 0.933333 21.0084 0 19.8584 0C18.7084 0 17.775 0.933333 17.775 2.08333V4.38333C17.775 5.53333 18.7084 6.46667 19.8584 6.46667ZM30.8 11C31.3334 11 31.8667 10.8 32.275 10.3917L33.9 8.76667C34.7167 7.95 34.7167 6.63333 33.9 5.81667C33.0834 5 31.7667 5 30.95 5.81667L29.325 7.44167C28.5084 8.25833 28.5084 9.575 29.325 10.3917C29.7334 10.8 30.2667 11 30.8 11ZM7.4417 29.3333L5.8167 30.9583C5.00003 31.775 5.00003 33.0917 5.8167 33.9083C6.22503 34.3167 6.75837 34.5167 7.2917 34.5167C7.82503 34.5167 8.35837 34.3167 8.7667 33.9083L10.3917 32.2833C11.2084 31.4667 11.2084 30.15 10.3917 29.3333C9.57503 28.5167 8.25837 28.5167 7.4417 29.3333ZM37.6334 17.7833H35.3334C34.1834 17.7833 33.25 18.7167 33.25 19.8667C33.25 21.0167 34.1834 21.95 35.3334 21.95H37.6334C38.7834 21.95 39.7167 21.0167 39.7167 19.8667C39.7167 18.7167 38.7834 17.7833 37.6334 17.7833ZM6.45837 19.8667C6.45837 18.7167 5.52503 17.7833 4.37503 17.7833H2.07503C0.925033 17.7833 -0.00830078 18.7167 -0.00830078 19.8667C-0.00830078 21.0167 0.925033 21.95 2.07503 21.95H4.37503C5.52503 21.95 6.45837 21.0167 6.45837 19.8667ZM32.2667 29.3333C31.45 28.5167 30.1334 28.5167 29.3167 29.3333C28.5 30.15 28.5 31.4667 29.3167 32.2833L30.9417 33.9083C31.35 34.3167 31.8834 34.5167 32.4167 34.5167C32.95 34.5167 33.4834 34.3167 33.8917 33.9083C34.7084 33.0917 34.7084 31.775 33.8917 30.9583L32.2667 29.3333ZM7.4417 10.3917C7.85003 10.8 8.38337 11 8.9167 11C9.45003 11 9.98337 10.8 10.3917 10.3917C11.2084 9.575 11.2084 8.25833 10.3917 7.44167L8.7667 5.81667C7.95003 5 6.63337 5 5.8167 5.81667C5.00003 6.63333 5.00003 7.95 5.8167 8.76667L7.4417 10.3917Z"
          fill="url(#paint0_radial_9893_2041)"
        />
        <path
          d="M25.9414 21.3001C27.2581 19.7751 27.1998 17.4668 25.7498 16.0168C24.2998 14.5668 21.9914 14.5085 20.4664 15.8251H20.4581L19.8498 16.4168L19.2748 15.8418H19.2664C17.7414 14.5335 15.4331 14.6001 13.9831 16.0501C12.5331 17.5001 12.4748 19.8085 13.7914 21.3335H13.7831L19.8748 27.4335L25.3748 21.9335L25.3581 21.9168L25.9664 21.3085H25.9581L25.9414 21.3001Z"
          fill="#3300FF"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_9893_2041"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(0.933364 -5.85) scale(62.6833)"
        >
          <stop stop-color="#3B6AF4" />
          <stop offset="0.69" stop-color="#19AEDF" />
          <stop offset="0.99" stop-color="#CBF0F8" />
        </radialGradient>
        <clipPath id="clip0_9893_2041">
          <rect width="39.725" height="39.725" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default Heart
